<template>
    <v-dialog
            v-model="dialog"
            width="500">

        <v-card>
            <v-card-title
                    class="title grey lighten-2"
                    primary-title>
                {{ title }}
            </v-card-title>

            <v-card-text class="pt-4">
                {{ body }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    @click="dialog = false"
                    depressed
                    large
                    height="44"
                    class="text-none"
                >
                    {{ button }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import {serverBus} from "../../main";

    export default {

        created () {
            serverBus.$on('show-message-dialog', (title, body, button = 'U redu') => {
                this.title = title;
                this.body = body;
                this.button = button;

                this.dialog = true;
            });
        },

        methods: {},

        data: function () {
            return {
                title: '',
                body: '',
                button: '',
                dialog: false
            }
        },

    }
</script>